import { render } from "./EntitlementUsageCard.vue?vue&type=template&id=f90d8094&scoped=true"
import script from "./EntitlementUsageCard.vue?vue&type=script&lang=js"
export * from "./EntitlementUsageCard.vue?vue&type=script&lang=js"

import "./EntitlementUsageCard.vue?vue&type=style&index=0&id=f90d8094&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f90d8094"]])

export default __exports__